/* global app */
/* global event */
/* global calendar */
/* global templateAllowedFields */
app.controller('registerCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification) {
    $scope.gui = {};
    $scope.gui.view = {};
    $scope.gui.view.visible = false;
    $scope.gui.registerButton = {disabled: true}
    
    $scope.registerData = {}
    
    $rootScope.$on("register_view", function(e, data){
        if(data.cmd == "open"){
            $scope.gui.view.visible = true;
        }
    })
    
    
    $scope.inputChanged = function(){
        if($scope.registerData.dsgvo != undefined && $scope.registerData.phone != undefined && $scope.registerData.email != undefined && $scope.registerData.password != undefined && $scope.registerData.secondname != undefined && $scope.registerData.firstname != undefined && $scope.registerData.dsgvo){
            $scope.gui.registerButton.disabled = false;
        }else{
            $scope.gui.registerButton.disabled = true;
        }
    }

    $rootScope.$on("createAccountAndRegisterForJob_Dialog", function(e,d){
        $scope.registerForJob = d.data;
    })

    $scope.showLoginView = function(){
        $scope.gui.view.visible = false;
        $rootScope.$emit("login_view", {cmd: "open"});
    }
    
    $scope.register = function(token){
        console.log($scope)
        var user = $scope.registerData;
        user.token = token;
        
        if($scope.registerForJob != undefined){
            user.registerForJob = true;
            user.job = $scope.registerForJob;
        }
        
        NetworkService.callOperation("registernewuser", user, function(response){
            if(response.get("status") == "EXISTING"){
                AtlasNotification.info("Dieser Account existiert schon");
            }else if(response.get("status") == "NOTUNLOCKED"){
                AtlasNotification.info("Dieser Account existiert schon. Bitte klick auf den Link in deiner Bestätigungsmail");
            }
            else if(response.get("status") == "ADDED"){
                AtlasNotification.info("Du hast dich erfolgreich registriert. Bitte klick auf den Link in deiner Bestätigungsmail");
                $scope.showLoginView();
            }
        })
    }
}])
